import { useEffect } from 'react';
import { useAppDispatch } from '../store/hooks';
import { setScrollPosition, setIsScrolling } from '../store/slices/uiSlice';
import { throttle } from '../utils/performance';

export const useScrollOptimization = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let scrollTimeout;
    let ticking = false;

    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    const delay = isMobile ? 32 : 16;
    const handleScroll = throttle(() => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          dispatch(setScrollPosition(window.scrollY));
          dispatch(setIsScrolling(true));
          ticking = false;

          // Clear scrolling state after scroll stops
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            dispatch(setIsScrolling(false));
          }, 150);
        });
        ticking = true;
      }
    }, delay);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, [dispatch]);
};

